/**
 * Como o card de menção mostra o texto (2026-10-31): a postagem (o trecho)
 * ou o resumo da IA. Preferência da PESSOA, gravada em `/me/preferences`
 * sob a chave `mention_text_view`. O padrão é a postagem.
 *
 * Espelho de `web_api/application/preferences.py`.
 */
export const MENTION_TEXT_VIEWS = ["post", "summary"] as const;

export type MentionTextView = (typeof MENTION_TEXT_VIEWS)[number];

export const DEFAULT_MENTION_TEXT_VIEW: MentionTextView = "post";

export const MENTION_TEXT_VIEW_LABELS: Record<MentionTextView, string> = {
  post: "Postagem",
  summary: "Resumo"
};

export function isMentionTextView(value: unknown): value is MentionTextView {
  return typeof value === "string" && (MENTION_TEXT_VIEWS as readonly string[]).includes(value);
}
